import dynamic from "next/dynamic";

import { handleComponentLoadError } from "@faire/retailer/lib/loadChunkErrors";

export const LazyAppModals = dynamic(
  () =>
    import(/* webpackChunkName: "retailer-app-modals" */ "./AppModals")
      .then((m) => ({ default: m.AppModals }))
      .catch(handleComponentLoadError),
  { ssr: false }
);
